const homeHandler = (url) => {
  if (/^\/network-home\/messages(\/)?(\?.*)?$/i.test(url)) {
    return url.replace(/^\/network-home\/messages/, "/messenger");
  }
  if (/^\/network-home\/focus\/birthdays(\/)?(\?.*)?$/i.test(url)) {
    return url.replace(/^\/network-home\/focus\/birthdays/, "/network/birthdays");
  }
  if (/^\/network-home\/focus\/profile-visits(\/)?(\?.*)?$/i.test(url)) {
    return url.replace(/^\/network-home\/focus\/profile-visits/, "/profile-visits");
  }
  if (/^\/network-home\/focus\/contact-requests(\/)?(\?.*)?$/i.test(url)) {
    return url.replace(/^\/network-home\/focus\/contact-requests/, "/network/requests");
  }
  if (/^\/network-home\/focus\/new-contacts(\/)?(\?.*)?$/i.test(url)) {
    return url.replace(/^\/network-home\/focus\/new-contacts/, "/network/contactlist");
  }
  if (/^\/network-home\/updates(\/.*)?(\?.*)?$/i.test(url)) {
    return url.replace(/^\/network-home\/updates/, "/home");
  }
  if (/^\/network-home(\/.*)?(\?.*)?$/i.test(url)) {
    return url.replace(/^\/network-home/, "/home");
  }
  if (/^\/discover(\/.*)?(\?.*)?$/i.test(url)) {
    return "/home";
  }
  return null;
};
export {
  homeHandler
};
